import { useEffect, useState } from 'react';
import api from '../../utils/api';

// One announcement row — either a scrolling marquee or a static centered line.
function Bar({ text, bg, color, fontSize, paddingY, scroll }) {
  const style = {
    backgroundColor: bg || '#F5B400',
    color: color || '#1a1a1a',
    fontSize: `${fontSize || 14}px`,
    paddingTop: `${paddingY ?? 6}px`,
    paddingBottom: `${paddingY ?? 6}px`,
  };

  if (scroll) {
    // Single sentence that enters from the right edge and scrolls off the left.
    return (
      <div className="w-full overflow-hidden" style={style}>
        <span className="announce-marquee font-semibold tracking-wide">{text}</span>
      </div>
    );
  }

  return (
    <div className="w-full" style={style}>
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-center text-center">
        <span className="font-semibold tracking-wide">{text}</span>
      </div>
    </div>
  );
}

export default function AnnouncementBar() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/banners/announcement').then(r => setData(r.data.data)).catch(() => {});
  }, []);

  if (!data?.is_active) return null;

  const messages = [
    { text: data.text,  bg: data.bg_color,  color: data.text_color,  fontSize: data.font_size,  paddingY: data.padding_y,  scroll: data.scroll },
    { text: data.text2, bg: data.bg_color2, color: data.text_color2, fontSize: data.font_size2, paddingY: data.padding_y2, scroll: data.scroll2 },
    { text: data.text3, bg: data.bg_color3, color: data.text_color3, fontSize: data.font_size3, paddingY: data.padding_y3, scroll: data.scroll3 },
  ].filter(m => m.text?.trim());

  if (messages.length === 0) return null;

  return (
    <div className="w-full">
      {messages.map((m, i) => <Bar key={i} {...m} />)}
    </div>
  );
}
